import React from 'react';
import PropTypes from 'prop-types';

import { Box, Tabs, Tab, Typography } from '@mui/material';

import {
  settingsTabsWrapperSx,
  settingsTabsSx,
  settingsTabIconSx
} from '../components/Styles/InputStyles';

const PageHeaderTabs = ({
  type = 'title',
  title = '',
  subtitle = '',
  value = 0,
  onChange,
  tabs = [],
  rightContent = null,
  headerHeight = 52
}) => {
  const showTabs = type === 'tabs';

  return (
    <Box
      sx={{
        ...settingsTabsWrapperSx,
        flexShrink: 0,
        position: 'relative',
        zIndex: 2,
        bgcolor: '#FFFFFF'
      }}>
      {showTabs ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            minWidth: 0
          }}>
          <Tabs
            value={value}
            onChange={onChange}
            sx={{
              ...settingsTabsSx,
              minWidth: 0,
              flex: 1
            }}
            variant="standard"
            scrollButtons="auto"
            allowScrollButtonsMobile>
            {tabs.map(tab => (
              <Tab
                key={tab.value ?? tab.label}
                value={tab.value}
                disabled={tab.disabled}
                icon={
                  tab.icon
                    ? React.cloneElement(tab.icon, {
                        // sx: {
                        //   ...settingsTabIconSx,
                        //   ...tab.iconSx,
                        //   fontSize: tab.iconSize ?? 20
                        // }
                      })
                    : undefined
                }
                iconPosition={tab.iconPosition || 'start'}
                label={tab.label}
                // sx={tab.sx}
              />
            ))}
          </Tabs>

          {rightContent && (
            <Box
              sx={{
                flexShrink: 0,
                px: 2
              }}>
              {rightContent}
            </Box>
          )}
        </Box>
      ) : (
        <Box
          sx={{
            ...settingsTabsSx,
            px: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 2,
            bgcolor: '#FFFFFF'
          }}>
          <Box sx={{ minWidth: 0 }}>
            <Typography
              component="h1"
              sx={{
                fontSize: 20,
                fontWeight: 500,
                color: '#212121',
                lineHeight: 1.2
              }}>
              {title}
            </Typography>

            {subtitle && (
              <Typography
                sx={{
                  mt: 0.5,
                  fontSize: 12,
                  color: '#757575'
                }}>
                {subtitle}
              </Typography>
            )}
          </Box>

          {rightContent && <Box sx={{ flexShrink: 0 }}>{rightContent}</Box>}
        </Box>
      )}
    </Box>
  );
};

PageHeaderTabs.propTypes = {
  type: PropTypes.oneOf(['tabs', 'title']),
  title: PropTypes.string,
  subtitle: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      icon: PropTypes.node,
      iconPosition: PropTypes.oneOf(['top', 'bottom', 'start', 'end']),
      disabled: PropTypes.bool,
      iconSx: PropTypes.object,
      sx: PropTypes.object
    })
  ),
  rightContent: PropTypes.node,
  headerHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default PageHeaderTabs;
